import Navigation from "./Navigation";
import { BaseFooter } from "./styles";

export default function Footer() {
  return (
    <BaseFooter>
      <Navigation />
    </BaseFooter>
  );
}
